var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonLogoFitgenieStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "49.999%",
    x2: "-.001%",
    y2: "49.999%",
    id: "common_logo_fitgenie_star_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11C969",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAD5E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.659%",
    y1: "30.872%",
    x2: "54.629%",
    y2: "52.468%",
    id: "common_logo_fitgenie_star_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CF69",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAD5E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.571%",
    y1: "20.158%",
    x2: "67.878%",
    y2: "65.619%",
    id: "common_logo_fitgenie_star_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D569",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAD5E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.374%",
    y1: "22.071%",
    x2: "78.078%",
    y2: "72.381%",
    id: "common_logo_fitgenie_star_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D469",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB360",
    offset: "77.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAD5E",
    offset: "91.13%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37A32.297 32.297 0 000 18.501 32.294 32.294 0 0018.5 0 32.31 32.31 0 0037 18.501 32.305 32.305 0 0018.5 37",
    id: "common_logo_fitgenie_star_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "common_logo_fitgenie_star_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#common_logo_fitgenie_star_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#common_logo_fitgenie_star_svg__b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.966 51.244H16.24c-5.095 0-9.226-4.11-9.226-9.18V23.431c0-5.07 4.13-9.18 9.226-9.18h18.727c5.096 0 9.226 4.11 9.226 9.18v18.633c0 5.07-4.13 9.18-9.226 9.18z",
    fill: "url(#common_logo_fitgenie_star_svg__c)",
    transform: "translate(-7 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.876.977c-.296 2.35-2.374 3.918-4.435 4.874-2.061.955-4.352 1.615-5.914 3.287-2.19 2.34-2.461 6.155-4.677 8.469-2.224 2.324-5.85 2.579-8.344 4.59-4.194 3.38-3.877 10.432-7.543 14.415-1.55 1.682-3.792 2.796-4.632 4.972-.864 2.234.075 4.908 1.533 6.9 1.859 2.537 4.576 4.397 7.517 5.15 3.184.815 6.536.338 9.48-.933 2.943-1.271 5.511-3.309 7.778-5.61 2.2-2.233 4.14-4.727 6.077-7.216 2.41-3.099 4.82-6.198 7.015-9.47 3.352-4.995 6.24-10.532 6.984-16.672.31-2.547.232-5.216-.667-7.668-.898-2.451-2.693-4.664-5.047-5.611-2.355-.947-5.237-.409-6.728 1.584",
    fill: "url(#common_logo_fitgenie_star_svg__d)",
    transform: "translate(-7 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.83 12.974c-2.275.929-4.824 1.287-6.768 2.84-3.224 2.576-4.13 7.93-7.893 9.495-1.885.783-4.077.382-5.957 1.175-3.226 1.361-4.349 5.562-6.853 8.106-1.68 1.709-3.96 2.635-5.637 4.343-1.92 1.956-2.89 4.909-2.54 7.724.348 2.815 2.007 5.428 4.343 6.834 1.992 1.202 4.338 1.52 6.62 1.605 3.147.117 6.291-.172 9.424-.459 3.17-.289 6.365-.583 9.408-1.549 3.042-.966 5.96-2.661 7.909-5.312 1.72-2.337 2.58-5.242 3.41-8.079 1.4-4.797 2.805-9.623 3.408-14.613.603-4.991.363-10.2-1.443-14.874-.336-.868-.978-2.489-1.96-2.746-.997-.263-.957.626-1.26 1.446-.742 1.987-2.36 3.308-4.211 4.064z",
    fill: "url(#common_logo_fitgenie_star_svg__e)",
    transform: "translate(-7 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.926 24.1c-.798 1.681-1.203 3.674-2.597 4.868-2.566 2.2-6.696.273-9.408 2.266-2.034 1.493-2.341 4.476-3.752 6.617-1.54 2.34-4.28 3.48-6.909 4.048-2.629.568-5.349.714-7.874 1.712-2.525.997-4.928 3.144-5.277 5.922a51.392 51.392 0 0020.732 8.209c2.299.366 4.835.528 6.845-.812 1.672-1.115 2.65-3.054 3.552-4.898l4.92-10.093c1.504-3.085 3.018-6.192 3.957-9.496.752-2.642 1.128-5.37 1.498-8.086.208-1.518 1.488-5.816-1.24-4.85-1.882.665-3.578 2.807-4.447 4.592z",
    fill: "url(#common_logo_fitgenie_star_svg__f)",
    transform: "translate(-7 -14)"
  })))));
}

export default SvgCommonLogoFitgenieStar;